<template>
  <div class="row" style="margin-top: 15px">
    <fieldset>
      <legend style="width: 410px">Atendimentos por Situação</legend>
      <div class="row">
        <div class="title-group">Período</div>
        <div class="group-itens">
          <div class="item-filter">
            <a-date-picker show-time type="date" placeholder="Data Início" style="width: 100%" format="DD/MM/yyyy" v-model:value="form.dataInicio" />
          </div>
          <div class="item-filter">
            <a-date-picker show-time type="date" placeholder="Data Fim" style="width: 100%" format="DD/MM/yyyy" v-model:value="form.dataFim" />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="title-group">Médico</div>
        <div class="col-12 col-md-6 group-itens">
          <select class="form-select" v-model="form.cpfMedico">
            <option></option>
            <option v-for="item in this.lstProfissional" :key="item.nome" :value="item.cpf">
              {{ item.nome }}
            </option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="title-group">Paciente</div>
        <div class="col-12 col-md-6 group-itens">
          <select class="form-select" v-model="form.cpfPaciente">
            <option></option>
            <option v-for="item in this.lstPaciente" :key="item.nome" :value="item.cpf">
              {{ item.nome }}
            </option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="title-group">Situação</div>
        <div class="group-itens">
          <Multiselect v-model="form.objetoConsulta" display="chip" placeholder="Selecione a situação" :maxSelectedLabels="3" class="w-10rem" :options="enumSituacaoAgendamento" optionValue="tipo" optionLabel="descricao"></Multiselect>
        </div>
      </div>
      <div class="row" style="margin-top: 15px">
        <div style="width: 180px">
          <a-tooltip title="Pesquisar" placement="top">
            <div class="input-group-prepend icon" style="text-align: center">
              <span class="input-group-text bg-white" @click="search">
                <i class="fa fa-search" style="margin: 0px 10px"></i>
                <span>Pesquisar</span>
              </span>
            </div>
          </a-tooltip>
        </div>
        <div class="col"></div>
        <div style="display: flex; flex-direction: row; width: 380px">
          <div style="width: 150px">
            <a-tooltip title="Imprimir" placement="top" v-if="registros.length > 0" @click="imprimirPDF">
              <div class="input-group-prepend icon" style="text-align: center">
                <span class="input-group-text bg-white">
                  <i class="fa-solid fa-print" style="margin: 0px 10px"></i>
                  <span>Imprimir</span>
                </span>
              </div>
            </a-tooltip>
          </div>
        </div>
      </div>
      <div class="row" style="margin-top: 10px">
        <a-table :dataSource="registros" :columns="columns"> </a-table>
      </div>
      <div id="iframe"></div>
    </fieldset>
  </div>
</template>
<!-- <template>
    <div class="row">
 
        <div class="col-2">

            <a-tooltip title="Imprimir" placement="top">
                <a @click="imprimirPDF"><i
                        class="fa-solid fa-print icon-print"></i></a>
            </a-tooltip>
            <a-tooltip title="Encaminhar" placement="top">
                <a @click="encaminharEmail">
                    <i class="fa-solid fa-share icon-print"></i>
                </a>
            </a-tooltip>
        </div>
        <div class="row" style="margin-top: 20px; margin-bottom: 20px">
            <div class="col-3">
               
            </div>
        </div>
        <div class="col">
            <div class="form-check">
                <input class="form-check-input" type="checkbox" value="todos" v-model="form.todos">
                <label class="form-check-label">
                    Todos
                </label>
            </div>
        </div>



    </div>
</template> -->

<script>
import { EnumSituacaoAgendamento } from '@/components/models/enumSituacaoAgendamento';
import { getSituacaoAgendamentoRelatorio } from '@/components/service/agendamento-medico';
import { gerarRelatorioPdf } from '@/components/service/gerarRelatorio';
import { getListaResumidaPaciente } from '@/components/service/pacienteService';
import { getListaProfissionaisResumida } from '@/components/service/profissionalService';
import { abrirImpressaoPorBlob, formatarData } from '@/utils/servicos-utils';

export default {
  name: 'AtendimentoSituacaoAgendamentoRelatorio',
  data() {
    return {
      dataInicio: null,
      dataFim: null,
      registros: [],
      lstProfissional: [],
      lstPaciente: [],
      convenios: ['IPASGO', 'PARTICULAR', 'DOACAO'],
      enumSituacaoAgendamento: EnumSituacaoAgendamento(),
      form: {
        todos: false,
        objetoConsulta: [],
        dataInicio: null,
        dataFim: null,
        cpfMedico: null,
        cpfPaciente: null,
      },
      pagination: {
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
      },
      columns: [
        {
          title: '#',
          dataIndex: 'index',
          key: 'index',
          width: 60,
        },
        {
          title: 'Paciente',
          dataIndex: 'paciente',
          key: 'paciente',
        },
        {
          title: 'Médico',
          dataIndex: 'profissional',
          key: 'profissional',
        },
        {
          title: 'Data',
          dataIndex: 'dataFormatada',
          key: 'dataFormatada',
        },
        {
          title: 'Situação',
          dataIndex: 'situacao',
          key: 'situacao',
        },
      ],
    };
  },

  methods: {
    async search() {
      let dataInicio = this.form.dataInicio;
      let dataFim = this.form.dataFim;
      if (this.form.dataInicio != null) {
        this.form.dataInicio = formatarData(new Date(this.form.dataInicio), 'DD/MM/YYYY');
        if (this.form.dataFim != null) {
          this.form.dataFim = formatarData(new Date(this.form.dataFim), 'DD/MM/YYYY');
        }
      }
      await getSituacaoAgendamentoRelatorio(this.form).then((r) => {
        this.form.dataInicio = dataInicio;
        this.form.dataFim = dataFim;
        this.registros = r.data;
        this.montarIndex();
      });
    },
    async imprimirPDF() {
      if (this.registros.length > 0) {
        await gerarRelatorioPdf({
          listaDadosDocumento: this.registros,
          nomeDocumentoHtml: 'relatorio-situacao-agendamento.html',
        }).then((r) => {
          abrirImpressaoPorBlob(r.data);
        });
      }
    },
    async carregarProfissionais() {
      await getListaProfissionaisResumida()
        .then((r) => {
          this.lstProfissional = r.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    async carregarPacientes() {
      await getListaResumidaPaciente()
        .then((r) => {
          this.lstPaciente = r.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    montarIndex() {
      this.registros.forEach((item, i) => {
        item.index = i + 1;
      });
    },
  },
  created() {
    this.carregarProfissionais();
    this.carregarPacientes();
  },
};
</script>

<style scoped>
.title-group {
  margin-bottom: 5px;
  font-size: 16px;
  font-weight: bold;
}

.group-itens {
  display: flex;
  flex-direction: row;
}

.form-check-label {
  font-size: 14px;
  margin: 0px 10px;
}

.input-group-prepend {
  cursor: pointer;
}

.input-group-text {
  padding: 0.375rem 26px 4px 11px;
  height: 38px;
}

.ant-table-thead > tr > th,
.ant-table-tbody > tr > td {
  background: #2bec96 !important;
}

.icon {
  cursor: pointer;
}

.item-filter {
  margin: 10px;
}

.item-filter.form-check-input {
  margin: 10px;
}
</style>
